// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dCoordinates from "../Data.Coordinates/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Restaumatic$dGeocoding$dTypes$dStreetAddress from "../Restaumatic.Geocoding.Types.StreetAddress/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const streetAddressIsSymbol = {reflectSymbol: () => "streetAddress"};
const ReverseGeocodeResponseIsSymbol = {reflectSymbol: () => "ReverseGeocodeResponse"};
const coordinatesIsSymbol = {reflectSymbol: () => "coordinates"};
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ReverseGeocodeRequestIsSymbol = {reflectSymbol: () => "ReverseGeocodeRequest"};
const decodeRecordCons2 = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1));
const GeocodeResponseIsSymbol = {reflectSymbol: () => "GeocodeResponse"};
const accountIdIsSymbol = {reflectSymbol: () => "accountId"};
const countryIsSymbol = {reflectSymbol: () => "country"};
const fromPSIsSymbol = {reflectSymbol: () => "fromPS"};
const GeocodeRequestIsSymbol = {reflectSymbol: () => "GeocodeRequest"};
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)};
const ReverseGeocodeResponse = x => x;
const ReverseGeocodeRequest = x => x;
const GeocodeResponse = x => x;
const GeocodeRequest = x => x;
const rPCSitesReverseGeocodeReq = {};
const rPCSitesGeocodeRequestGeo = {};
const rPCMethodNameReverseGeoco = {rpcMethodName: v => "ReverseGeocodeRequest"};
const rPCMethodNameGeocodeReque = {rpcMethodName: v => "GeocodeRequest"};
const newtypeReverseGeocodeResp = {Coercible0: () => {}};
const newtypeReverseGeocodeRequ = {Coercible0: () => {}};
const newtypeGeocodeResponse_ = {Coercible0: () => {}};
const newtypeGeocodeRequest_ = {Coercible0: () => {}};
const hasFieldReverseGeocodeRes = dictHasField => dictHasField;
const hasFieldReverseGeocodeReq = dictHasField => dictHasField;
const hasFieldGeocodeResponse = dictHasField => dictHasField;
const hasFieldGeocodeRequest = dictHasField => dictHasField;
const eqReverseGeocodeResponse = {
  eq: x => y => {
    if (x.streetAddress.tag === "Nothing") { return y.streetAddress.tag === "Nothing"; }
    if (x.streetAddress.tag === "Just") {
      if (y.streetAddress.tag === "Just") {
        return x.streetAddress._1.city === y.streetAddress._1.city && x.streetAddress._1.street === y.streetAddress._1.street && x.streetAddress._1.streetNumber === y.streetAddress._1.streetNumber;
      }
      return false;
    }
    return false;
  }
};
const eqReverseGeocodeRequest = {
  eq: x => y => x.coordinates.lat === y.coordinates.lat && x.coordinates.lon === y.coordinates.lon && (() => {
    if (x.restaurantId.tag === "Nothing") { return y.restaurantId.tag === "Nothing"; }
    if (x.restaurantId.tag === "Just") {
      if (y.restaurantId.tag === "Just") { return x.restaurantId._1 === y.restaurantId._1; }
      return false;
    }
    return false;
  })()
};
const eqGeocodeResponse = {
  eq: x => y => {
    if (x.coordinates.tag === "Nothing") { return y.coordinates.tag === "Nothing"; }
    if (x.coordinates.tag === "Just") {
      if (y.coordinates.tag === "Just") { return x.coordinates._1.lat === y.coordinates._1.lat && x.coordinates._1.lon === y.coordinates._1.lon; }
      return false;
    }
    return false;
  }
};
const eqGeocodeRequest = {
  eq: x => y => (() => {
    if (x.accountId.tag === "Nothing") { return y.accountId.tag === "Nothing"; }
    if (x.accountId.tag === "Just") {
      if (y.accountId.tag === "Just") { return x.accountId._1 === y.accountId._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.country.tag === "PL") { return y.country.tag === "PL"; }
    if (x.country.tag === "GB") { return y.country.tag === "GB"; }
    if (x.country.tag === "RU") { return y.country.tag === "RU"; }
    if (x.country.tag === "RO") { return y.country.tag === "RO"; }
    if (x.country.tag === "CZ") { return y.country.tag === "CZ"; }
    if (x.country.tag === "HR") { return y.country.tag === "HR"; }
    if (x.country.tag === "SK") { return y.country.tag === "SK"; }
    if (x.country.tag === "DE") { return y.country.tag === "DE"; }
    if (x.country.tag === "NL") { return y.country.tag === "NL"; }
    if (x.country.tag === "ES") { return y.country.tag === "ES"; }
    if (x.country.tag === "BR") { return y.country.tag === "BR"; }
    if (x.country.tag === "IT") { return y.country.tag === "IT"; }
    if (x.country.tag === "SI") { return y.country.tag === "SI"; }
    return false;
  })() && (() => {
    if (x.fromPS.tag === "Nothing") { return y.fromPS.tag === "Nothing"; }
    if (x.fromPS.tag === "Just") {
      if (y.fromPS.tag === "Just") { return x.fromPS._1 === y.fromPS._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.restaurantId.tag === "Nothing") { return y.restaurantId.tag === "Nothing"; }
    if (x.restaurantId.tag === "Just") {
      if (y.restaurantId.tag === "Just") { return x.restaurantId._1 === y.restaurantId._1; }
      return false;
    }
    return false;
  })() && x.streetAddress.city === y.streetAddress.city && x.streetAddress.street === y.streetAddress.street && x.streetAddress.streetNumber === y.streetAddress.streetNumber
};
const genericReverseGeocodeResponse = {to: x => x, from: x => x};
const showReverseGeocodeResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.streetAddress.tag === "Just") {
            return "{ streetAddress: (Just " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress._1) + ") }";
          }
          if (v.streetAddress.tag === "Nothing") { return "{ streetAddress: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(ReverseGeocodeResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeReverseGeocodeResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dStreetAddress.unscrambleDecodeStreetAddress))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericReverseGeocodeRequest = {to: x => x, from: x => x};
const showReverseGeocodeRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ coordinates: " + Data$dCoordinates.showCoordinates.show(v.coordinates) + ", restaurantId: " + showMaybe.show(v.restaurantId) + " " + "}"]
    })(ReverseGeocodeRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeReverseGeocodeRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Data$dCoordinates.unscrambleDecodeCoordinates)(decodeRecordCons2(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGeocodeResponse = {to: x => x, from: x => x};
const showGeocodeResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.coordinates.tag === "Just") { return "{ coordinates: (Just " + Data$dCoordinates.showCoordinates.show(v.coordinates._1) + ") }"; }
          if (v.coordinates.tag === "Nothing") { return "{ coordinates: Nothing }"; }
          $runtime.fail();
        })()
      ]
    })(GeocodeResponseIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGeocodeResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(coordinatesIsSymbol)(Unscramble.decodeMaybe(Data$dCoordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGeocodeRequest = {to: x => x, from: x => x};
const showGeocodeRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.accountId.tag === "Just") {
            return "{" + " accountId: (Just " + Data$dShow.showIntImpl(v.accountId._1) + ")" + ", country: " + Restaumatic$dCountries.showCountry.show(v.country) + (() => {
              if (v.fromPS.tag === "Just") {
                if (v.fromPS._1) {
                  return ", fromPS: (Just true), restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
                }
                return ", fromPS: (Just false), restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
              }
              if (v.fromPS.tag === "Nothing") {
                return ", fromPS: Nothing, restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
              }
              $runtime.fail();
            })() + "}";
          }
          if (v.accountId.tag === "Nothing") {
            return "{ accountId: Nothing, country: " + Restaumatic$dCountries.showCountry.show(v.country) + (() => {
              if (v.fromPS.tag === "Just") {
                if (v.fromPS._1) {
                  return ", fromPS: (Just true), restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
                }
                return ", fromPS: (Just false), restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
              }
              if (v.fromPS.tag === "Nothing") {
                return ", fromPS: Nothing, restaurantId: " + showMaybe.show(v.restaurantId) + ", streetAddress: " + Restaumatic$dGeocoding$dTypes$dStreetAddress.showStreetAddress.show(v.streetAddress) + " ";
              }
              $runtime.fail();
            })() + "}";
          }
          $runtime.fail();
        })()
      ]
    })(GeocodeRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGeocodeRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(accountIdIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic$dCountries.unscrambleDecodeCountry)(Unscramble.decodeRecordCons(fromPSIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(decodeRecordCons2(Unscramble.decodeRecordCons(streetAddressIsSymbol)(Restaumatic$dGeocoding$dTypes$dStreetAddress.unscrambleDecodeStreetAddress)(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeReverseGeocodeResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dStreetAddress.encodeStreetAddress.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeReverseGeocodeRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)(encodeWithOptionsOther))(coordinatesIsSymbol)({
      encodeWithOptions: v => Data$dCoordinates.encodeCoordinates.encode
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGeocodeResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(coordinatesIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Data$dCoordinates.encodeCoordinates.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGeocodeRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GeocodeRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(streetAddressIsSymbol)({
      encodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dStreetAddress.encodeStreetAddress.encode
    }))(restaurantIdIsSymbol)(encodeWithOptionsOther))(fromPSIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(countryIsSymbol)({encodeWithOptions: v => Restaumatic$dCountries.encodeCountry.encode}))(accountIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeReverseGeocodeResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericReverseGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ReverseGeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dStreetAddress.decodeStreetAddress.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeReverseGeocodeRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericReverseGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ReverseGeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)(decodeWithOptionsOther)())(coordinatesIsSymbol)({
    decodeWithOptions: v => Data$dCoordinates.decodeCoordinates.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGeocodeResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGeocodeResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GeocodeResponseIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(coordinatesIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dCoordinates.decodeCoordinates.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGeocodeRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGeocodeRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GeocodeRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(streetAddressIsSymbol)({
    decodeWithOptions: v => Restaumatic$dGeocoding$dTypes$dStreetAddress.decodeStreetAddress.decode
  })())(restaurantIdIsSymbol)(decodeWithOptionsOther)())(fromPSIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.booleanDecode.decode)
  })())(countryIsSymbol)({decodeWithOptions: v => Restaumatic$dCountries.decodeCountry.decode})())(accountIdIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  GeocodeRequest,
  GeocodeRequestIsSymbol,
  GeocodeResponse,
  GeocodeResponseIsSymbol,
  ReverseGeocodeRequest,
  ReverseGeocodeRequestIsSymbol,
  ReverseGeocodeResponse,
  ReverseGeocodeResponseIsSymbol,
  accountIdIsSymbol,
  coordinatesIsSymbol,
  countryIsSymbol,
  decodeGeocodeRequest,
  decodeGeocodeResponse,
  decodeRecordCons2,
  decodeReverseGeocodeRequest,
  decodeReverseGeocodeResponse,
  decodeWithOptionsOther,
  encodeGeocodeRequest,
  encodeGeocodeResponse,
  encodeReverseGeocodeRequest,
  encodeReverseGeocodeResponse,
  encodeWithOptionsOther,
  eqGeocodeRequest,
  eqGeocodeResponse,
  eqReverseGeocodeRequest,
  eqReverseGeocodeResponse,
  fromPSIsSymbol,
  genericGeocodeRequest,
  genericGeocodeResponse,
  genericReverseGeocodeRequest,
  genericReverseGeocodeResponse,
  hasFieldGeocodeRequest,
  hasFieldGeocodeResponse,
  hasFieldReverseGeocodeReq,
  hasFieldReverseGeocodeRes,
  newtypeGeocodeRequest_,
  newtypeGeocodeResponse_,
  newtypeReverseGeocodeRequ,
  newtypeReverseGeocodeResp,
  rPCMethodNameGeocodeReque,
  rPCMethodNameReverseGeoco,
  rPCSitesGeocodeRequestGeo,
  rPCSitesReverseGeocodeReq,
  restaurantIdIsSymbol,
  showGeocodeRequest,
  showGeocodeResponse,
  showMaybe,
  showReverseGeocodeRequest,
  showReverseGeocodeResponse,
  streetAddressIsSymbol,
  unscrambleDecodeGeocodeRequest,
  unscrambleDecodeGeocodeResponse,
  unscrambleDecodeReverseGeocodeRequest,
  unscrambleDecodeReverseGeocodeResponse
};
